<template>
  <div>
    <div class="margin-body d-flex align-items-start justify-content-between">

      <div style="width: 200px;">
        <img v-if="this.picture" :src="this.picture" style="max-width: 200px" width="auto" height="48px">
        <img v-else :src="brandLogo" alt="Logo"
             class="mt-auto mb-auto sidebar-header-logo-back"
             width="200px">
      </div>

      <b-input-group
        class="search-input-group"
        size="sm">
        <b-form-input
          id="search"
          v-model="search"
          :class="{'active': search}"
          :placeholder="$t('Research')"
          type="search"
          v-on:keyup.enter="fetchDashboardData">
        </b-form-input>
        <b-input-group-append class="search-input-append" @click="fetchDashboardData">
          <b-input-group-text id="search-input-append-text">
            <search-icon color="white" size="18"/>
          </b-input-group-text>
        </b-input-group-append>
      </b-input-group>

      <b-navbar-nav class="d-none d-md-block">

        <b-nav-item-dropdown class="d-flex align-items-end justify-content-end" right style="width: 300px;">
          <!-- Using 'button-content' slot -->
          <template #button-content>
            {{ $store.getters.username }}
          </template>
          <b-dropdown-item @click="goToProfile">
            {{ $t('Profile') }}
          </b-dropdown-item>
          <b-dropdown-item @click="showMyAccountModal">
            {{ $t('user.Password') }}
          </b-dropdown-item>
          <b-dropdown-item @click="showReportBugModal">
            {{ $t('Report.a.bug') }}
          </b-dropdown-item>
          <b-dropdown-item @click="logout">
            {{ $t('Logout') }}
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </div>

    <div class="margin-body backgrey">
      <div v-if="$store.getters.impersonateUsername" class="impersonate mb-2">
        <div class="impersonate-text ml-2"> Vous êtes connecté en tant que {{
            $store.getters.impersonateUsername
          }}
        </div>
        <button data-v-7ba5bd90="" type="button" class="btn mt-2 mb-2 mr-4 btn-impersonate" @click="backToAdmin"> Retour à l'admin
        </button>
      </div>
      <div class="row d-flex align-items-start m-0">
        <div
          :class="selectedLocation ? 'filterdiv filter filterselected d-flex justify-content-between rounded' : 'filterdiv filter d-flex justify-content-between rounded'">
          <b-dropdown id="filterLocation" class="filter rounded" left no-caret variant="white">
            <template v-if="selectedLocation" #button-content>
              {{ selectedLocation }}
            </template>
            <template v-else #button-content>
              {{ $t('venteLot.Localisation') }}
            </template>
            <b-dropdown-item @click="changeLocation('')">
              {{ $t('venteLot.Localisation') }}
            </b-dropdown-item>
            <b-dropdown-item v-for="(location, index) in locations" :key="'location-' + index"
                             @click="changeLocation(location)">
              {{ location }}
            </b-dropdown-item>
          </b-dropdown>
          <b-icon-chevron-right class="ml-auto mb-auto mt-auto mr-2" scale="1.5"
                                style="color: var(--tertiary-text-color);"/>
        </div>
        <div
          :class="selectedStatut ? 'filterdiv filter filterselected d-flex justify-content-between rounded ml-3' : 'filterdiv filter d-flex justify-content-between rounded ml-3'">
          <b-dropdown id="filterStatut" class="filter rounded" left no-caret variant="white">
            <template v-if="selectedStatut" #button-content>
              {{ $t(selectedStatut.text) }}
            </template>
            <template v-else #button-content>
              {{ $t('venteLot.Statut') }}
            </template>
            <b-dropdown-item @click="changeStatut(null)">
              {{ $t('venteLot.Statut') }}
            </b-dropdown-item>
            <b-dropdown-item v-for="(statut, index) in statuts" :key="'statut-' + index" @click="changeStatut(statut)">
              <span v-if="statut.value !== 'A_VALIDER'">
                {{ $t(statut.text) }}
              </span>
            </b-dropdown-item>
          </b-dropdown>
          <b-icon-chevron-right class="ml-auto mb-auto mt-auto mr-2" scale="1.5"
                                style="color: var(--tertiary-text-color);"/>
        </div>
        <div
          :class="(surfaceMax < 1000 || surfaceMin > 0) ? 'filterdiv filter filterselected d-flex justify-content-between rounded ml-3' : 'filterdiv filter d-flex justify-content-between rounded ml-3'">
          <b-dropdown id="filterSurface" ref="dropdownSurface" class="filter rounded" left no-caret variant="white">
            <template v-if="(surfaceMax < 1000 || surfaceMin > 0)" #button-content>
              {{ surfaceMin + 'm² - ' + surfaceMax + 'm²' }}
            </template>
            <template v-else #button-content>
              {{ $t('venteLot.Surface') }}
            </template>
            <b-dropdown-form class="surface-dropdown">
              {{ $t('venteLot.selectSurface') }}
              <DoubleRangeSlider :key="sliderKey" :max="1000" :min="0" class="mt-2"
                                 @update:min="value => changeSurfaceMin(value)"
                                 @update:max="value => changeSurfaceMax(value)"/>

              <div class="row mt-2">
                <b-form-input
                  id="dropdown-form-email"
                  v-model="surfaceMin"
                  v-disable-scroll
                  class="col-md-5 mr-auto"
                  size="sm"
                  type="number"
                  @change="fetchDashboardData"/>
                <b-form-input
                  id="dropdown-form-email"
                  v-model="surfaceMax"
                  v-disable-scroll
                  class="col-md-5 ml-auto"
                  size="sm"
                  type="number"
                  @change="fetchDashboardData"/>
              </div>
            </b-dropdown-form>
          </b-dropdown>
          <b-icon-chevron-right class="ml-auto mb-auto mt-auto mr-2" scale="1.5"
                                style="color: var(--tertiary-text-color);"/>
        </div>
        <div
          :class="selectedType ? 'filterdiv filter filterselected d-flex justify-content-between rounded ml-3' : 'filterdiv filter d-flex justify-content-between rounded ml-3'">
          <b-dropdown id="filterType" class="filter rounded" left no-caret variant="white">
            <template v-if="selectedType" #button-content style="">
              {{ selectedType }}
            </template>
            <template v-else #button-content>
              {{ $t('venteLot.Type') }}
            </template>
            <b-dropdown-item @click="changeType('')">
              {{ $t('venteLot.Type') }}
            </b-dropdown-item>
            <b-dropdown-item v-for="(type, index) in types" :key="'type-' + index" @click="changeType(type)">
              {{ type }}
            </b-dropdown-item>
          </b-dropdown>
          <b-icon-chevron-right class="ml-auto mb-auto mt-auto mr-2" scale="1.5"
                                style="color: var(--tertiary-text-color);"/>
        </div>
        <div
          :class="selectedBrut ? 'filterdiv filter filterselected d-flex justify-content-between rounded ml-3' : 'filterdiv filter d-flex justify-content-between rounded ml-3'">
          <b-dropdown id="filterBrut" class="filter rounded" left no-caret variant="white">
            <template v-if="selectedBrut" #button-content>
              {{ $t(selectedBrut.text) }}
            </template>
            <template v-else #button-content>
              {{ $t('venteLot.Etat') }}
            </template>
            <b-dropdown-item @click="changeBrut('')">
              {{ $t('venteLot.Etat') }}
            </b-dropdown-item>
            <b-dropdown-item v-for="(brut, index) in bruts" :key="'brut-' + index" @click="changeBrut(brut)">
              {{ $t(brut.text) }}
            </b-dropdown-item>
          </b-dropdown>
          <b-icon-chevron-right class="ml-auto mb-auto mt-auto mr-2" scale="1.5"
                                style="color: var(--tertiary-text-color);"/>
        </div>
      </div>

      <div v-if="totalCount <= 0" class="page-subtitle mt-4 ml-0">{{ $t('aucune.annonce') }}</div>
      <div v-if="totalCount === 1" class="page-subtitle mt-4 ml-0">{{ totalCount }} {{ $t('annonce') }}</div>
      <div v-if="totalCount > 1" class="page-subtitle mt-4 ml-0">{{ totalCount }} {{ $t('annonces') }}</div>

      <div class="row mt-3 row-cols-4">
        <div v-for="vente in venteLots" class="col mb-4">
          <b-card class="shadow" @click="showVente(vente.id)">
            <div class="d-flex align-items-start">
              <img v-if="vente.fileUrl" :src="vente.fileUrl" alt="Photo" class="annonce-photo ml-auto mr-auto img-fluid" />
              <img v-else :src="require(`@/assets/images/APRILYOS/sidebar-logo-user.png`)"
                   alt="Photo" class="annonce-photo ml-auto mr-auto"/>
              <span v-if="vente.statut === 'DISPONIBLE'" class="dispo p-2 position-absolute">
                  {{ $t('vente.lot.statut.enum.disponible') }}
              </span>
              <span v-if="vente.statut === 'VENDU'" class="vendu p-2 position-absolute">
                  {{ $t('vente.lot.statut.enum.vendu') }}
              </span>
              <span v-if="vente.statut === 'PRE_RESERVE' || vente.statut === 'A_VALIDER'"
                    class="prereserver p-2 position-absolute">
                  {{ $t('vente.lot.statut.enum.prereserve') }}
              </span>
              <span class="brutrenove p-2 position-absolute">
                  {{ vente.brutRenove }}
              </span>
            </div>
            <div class="row mt-2">
              <div class="name-header">
                <div class="annnonce-title ">{{ vente.name }}</div>
                <div class="prixVente">{{ convertCentsToEuros(vente.prix) }}€</div>
              </div>
              <div class="col-md-12 d-flex align-items-start mt-3">
                <svg class="mr-2 icon icon-tabler icons-tabler-outline icon-tabler-map-pin" fill="none" height="24"
                     stroke="#6D84C4" stroke-linecap="round"
                     stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24"
                     xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 0h24v24H0z" fill="none" stroke="none"/>
                  <path d="M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"/>
                  <path d="M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z"/>
                </svg>
                {{ vente.address }}
              </div>
              <div class="col-md-6 d-flex align-items-start mt-3">
                <svg class="mr-2 icon icon-tabler icons-tabler-outline icon-tabler-building-community" fill="none"
                     height="24" stroke="#6D84C4" stroke-linecap="round"
                     stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24"
                     xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 0h24v24H0z" fill="none" stroke="none"/>
                  <path d="M8 9l5 5v7h-5v-4m0 4h-5v-7l5 -5m1 1v-6a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v17h-8"/>
                  <path d="M13 7l0 .01"/>
                  <path d="M17 7l0 .01"/>
                  <path d="M17 11l0 .01"/>
                  <path d="M17 15l0 .01"/>
                </svg>
                {{ vente.type }}
              </div>
              <div class="col-md-6 d-flex align-items-start mt-3">
                <svg class="mr-2 icon icon-tabler icons-tabler-outline icon-tabler-ruler" fill="none" height="24"
                     stroke="#6D84C4" stroke-linecap="round"
                     stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24"
                     xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 0h24v24H0z" fill="none" stroke="none"/>
                  <path
                    d="M5 4h14a1 1 0 0 1 1 1v5a1 1 0 0 1 -1 1h-7a1 1 0 0 0 -1 1v7a1 1 0 0 1 -1 1h-5a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1"/>
                  <path d="M4 8l2 0"/>
                  <path d="M4 12l3 0"/>
                  <path d="M4 16l2 0"/>
                  <path d="M8 4l0 2"/>
                  <path d="M12 4l0 3"/>
                  <path d="M16 4l0 2"/>
                </svg>
                {{ vente.surface }}m²
              </div>
            </div>
          </b-card>
        </div>
      </div>

    </div>

  </div>
</template>

<script>

import api from '../../services/api'
import DoubleRangeSlider from '../venteLot/DoubleRangeSlider.vue'
import TokenService from '../../services/tokenService'
import {mapActions, mapGetters} from 'vuex'
import {bus} from '../../main'

export default {
  name: 'DashboardAgentImmo',

  components: {DoubleRangeSlider},

  data () {
    return {
      locations: [],
      statuts: [],
      bruts: [],
      types: [],
      selectedLocation: '',
      selectedType: '',
      selectedStatut: '',
      selectedBrut: '',
      surfaceMin: 0,
      sliderKey: 0,
      surfaceMax: 1000,
      totalCount: 0,
      search: '',
      venteLots: [],
      picture: null
    }
  },

  created () {
    bus.$on('changingImpersonate', () => {
      this.forceSideMenuRerender()
    })
  },

  mounted () {
    this.fetchData()
    this.$root.$on('bv::dropdown::shown', bvEvent => {
      this.sliderKey = 1
    })
  },

  computed: {
    ...mapGetters('brand', ['brand']),

    brandLogo() {
      console.log(this.brand.key)
      return require(`@/assets/images/${this.brand.key}/logo.png`)
    },
  },

  methods: {

    ...mapActions(['leaveImpersonateMode']),

    forceSideMenuRerender () {
      this.sideMenuKey++
    },

    backToAdmin () {
      TokenService.removeImpersonate()
      this.leaveImpersonateMode()
      this.forceSideMenuRerender()
      this.$router.push({
        name: 'Dashboard'
      })
    },

    async fetchData () {
      await this.fetchUserInfos()
      await this.fetchLocations()
      await this.fetchTypes()
      await this.fetchStatuts()
      await this.fetchBruts()
      await this.fetchDashboardData()
    },

    async fetchUserInfos () {
      if (this.$store.getters.isAuthenticated) {
        await api
          .get(`/user/getUserInfos`)
          .then(async response => {
            this.picture = response.data.picture
          })
      }
    },

    convertCentsToEuros (value) {
      return value * 0.01
    },

    async fetchDashboardData () {
      let formData = new FormData()
      formData.append('search', this.search)
      formData.append('location', this.selectedLocation)
      if (this.selectedStatut) {
        formData.append('statut', this.selectedStatut.value)
      } else {
        formData.append('statut', '')
      }
      if (this.selectedBrut) {
        formData.append('brut', this.selectedBrut.value)
      } else {
        formData.append('brut', '')
      }
      formData.append('type', this.selectedType)
      formData.append('surfaceMin', this.surfaceMin)
      formData.append('surfaceMax', this.surfaceMax)

      await api({
        method: 'POST',
        url: `/venteLot/getDashboardAgentImmoInfos`,
        data: formData
      })
        .then(response => {
          this.venteLots = response.data
          this.totalCount = response.data.length
        })
    },

    async fetchLocations () {
      await api
        .get(`/venteLot/getLocations`)
        .then(response => {
          this.locations = response.data
        })
    },

    async fetchTypes () {
      await api
        .get(`/venteLot/getTypes`)
        .then(response => {
          this.types = response.data
        })
    },

    async fetchBruts () {
      await api
        .get(`/venteLot/getStatutLot`)
        .then(response => {
          this.bruts = response.data
        })
    },

    async fetchStatuts () {
      await api
        .get(`/venteLot/getStatutVentes`)
        .then(response => {
          this.statuts = response.data
          this.selectedStatut = this.statuts.at(0)
        })
    },

    async logout () {
      this.$store.commit('setUnsavedChanges', false)
      await this.$store.dispatch('LogOut')
      await this.$router.push('/login')
    },

    showMyAccountModal () {
      this.$bvModal.show('change-password-modal')
    },

    goToProfile () {
      this.$router.push({
        name: 'ProfileShow'
      })
    },

    showReportBugModal () {
      this.$bvModal.show('show-bug-report-modal')
    },

    showVente (venteLotId) {
      this.$router.push({
        name: 'VenteLotShowAgent',
        params: {
          venteLotId: venteLotId
        }
      })
    },

    changeLocation (location) {
      this.selectedLocation = location
      const locationButton = document.getElementById('filterLocation__BV_toggle_')
      this.changeButtonColor(locationButton, this.selectedLocation)
      this.fetchDashboardData()
      this.sliderKey += 1
    },

    changeType (type) {
      this.selectedType = type
      const locationButton = document.getElementById('filterType__BV_toggle_')
      this.changeButtonColor(locationButton, this.selectedType)
      this.fetchDashboardData()
      this.sliderKey += 1
    },

    changeBrut (brut) {
      this.selectedBrut = brut
      const locationButton = document.getElementById('filterBrut__BV_toggle_')
      this.changeButtonColor(locationButton, this.selectedBrut)
      this.fetchDashboardData()
      this.sliderKey += 1
    },

    changeStatut (statut) {
      this.selectedStatut = statut
      const locationButton = document.getElementById('filterStatut__BV_toggle_')
      this.changeButtonColor(locationButton, this.selectedStatut)
      this.fetchDashboardData()
      this.sliderKey += 1
    },

    changeSurfaceMax (value) {
      this.surfaceMax = value
      this.changeSurfaceButtonColor()
      this.fetchDashboardData()
    },

    changeSurfaceMin (value) {
      this.surfaceMin = value
      this.changeSurfaceButtonColor()
      this.fetchDashboardData()
    },

    changeSurfaceButtonColor () {
      const element = document.getElementById('filterSurface__BV_toggle_')
      if (this.surfaceMin > 0 || this.surfaceMax < 1000) {
        element.style.setProperty('color', '#6D84C4')
        element.style.setProperty('font-weight', 'bold')
      } else {
        element.style.setProperty('color', '#07153C')
        element.style.setProperty('font-weight', 'inherit')
      }
    },

    changeButtonColor (element, selectedValue) {
      if (selectedValue) {
        element.style.setProperty('color', '#6D84C4')
        element.style.setProperty('font-weight', 'bold')
      } else {
        element.style.setProperty('color', '#07153C')
        element.style.setProperty('font-weight', 'inherit')
      }
    }
  }

}
</script>

<style scoped>

.margin-body {
  padding: 25px 100px;
  background-color: white;
}

.search-input-group {
  margin-right: 5rem;
  margin-left: 5rem;
}

#search {
  height: 42px;
  border-color: #6D84C4;
  color: #6D84C4;
  border-right: 0;
}

.search-input-append {
  border-color: #6D84C4;
  color: #6D84C4;
  background-color: white;
}

#search::placeholder {
  color: #6D84C4;
}

#search-input-append-text {
  background-color: var(--main-color);;
  border: 1px;
  border-radius: 4px;
}

.sidebar-header-logo-back {
  margin-right: 100px;
}

.backgrey {
  background-color: var(--background-grey);
}

.filter {
  width: 250px;
  background-color: white;
}

.filterselected {
  border: 2px solid var(--bleuet);
}

.filterdiv {
  height: 46px;
}

.annonce-photo {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.annnonce-title {
  color: var(--main-color);;
  font-size: 18px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.dispo {
  border-radius: 30px;
  text-align: center;
  background: #06C9B3;
  color: white;
  right: 15px;
}

.prereserver {
  border-radius: 30px;
  text-align: center;
  background: #009DFF;
  color: white;
  right: 15px;
}

.vendu {
  border-radius: 30px;
  text-align: center;
  background: #FF9D00;
  color: white;
  right: 15px;
}

.brutrenove {
  border-radius: 30px;
  text-align: center;
  background: #EAEDF4;
  color: var(--main-color);
  left: 15px;
}

.surface-dropdown {
  width: 250px;
  padding: 0 !important;
}

.btn {
  background-color: var(--main-color);
  color: red !important;
  border: 1px solid var(--main-color);;
}

>>> .dropdown-toggle {
  text-align: inherit !important;
}

.impersonate {
  background-color: var(--main-color);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-radius: var(--main-border-radius);
}

.btn-impersonate{
  background-color: var(--secondary-color);
  border-color: var(--secondary-color);
  color: var(--main-white)!important;
  border-radius: var(--main-border-radius);
  padding: 12px 20px;
  font-size: var(--content-font-size);
}

.btn-impersonate:hover:not([disabled]), .btn-impersonate:focus, .btn-impersonate:active {
  background-color: var(--secondary-color-hover) !important;
  border-color: var(--secondary-color-hover) !important;
  color: var(--main-white) !important;
}

.impersonate-text {
  align-self: center;
  color: var(--main-white);
}

.name-header{
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 15px;
  margin-top: 5px

}
.prixVente {
  color: var(--tertiary-text-color);
  font-size: 16px;
  font-family: "Montserrat-Bold", "Arial", sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/DashboardAgentImmo.vue